// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from './router'
import store from './store/index'
import App from './App'

// 3rd party
import VueMasonry from 'vue-masonry-css'
import * as VueGoogleMaps from 'vue2-google-maps'
import Buefy from 'buefy'
import VueAWN from 'vue-awesome-notifications'
import VueTour from 'vue-tour'

// FontAwesome
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'

// eslint-disable-next-line
import Filters from './lib/Filters'

// Create Element.remove() function if not exist
// patch for ie11
if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this)
    }
  }
}

// Create Element.closest() function if not exist
// patch for ie11
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this

    do {
      if (el.matches(s)) return el
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}

library.add(fas)
library.add(far)
Vue.component('font-awesome-icon', FontAwesomeIcon)
dom.watch()

require('./assets/scss/app.scss')

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueMasonry)
Vue.use(VueGoogleMaps)
Vue.use(VueTour)

Vue.component('treeselect', Treeselect)

// https://buefy.github.io/documentation/constructor-options
Vue.use(Buefy, {
  defaultIconPack: 'fas',
  defaultContainerElement: '#app',
  defaultToastDuration: 8000,
  defaultToastPosition: 'is-top',
  defaultSnackbarPosition: 'is-top'
})

Vue.use(VueAWN, {
  position: 'bottom-left',
  maxNotifications: 6,
  durations: {
    global: 3000,
    success: 4000,
    warning: 5000,
    alert: 10000
  },
  labels: {
    success: 'Success!',
    warning: 'Warning!',
    alert: 'Oops!',
    info: 'Heads Up!'
  }
})

Vue.prototype.$api = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

console.info('' +
  '                                                                                 \n' +
  '88888888888 8888888b.  8888888888 888     888 888b    888 8888888888 88888888888 \n' +
  '    888     888   Y88b 888        888     888 8888b   888 888            888     \n' +
  '    888     888    888 888        888     888 88888b  888 888            888     \n' +
  '    888     888   d88P 8888888    Y88b   d88P 888Y88b 888 8888888        888     \n' +
  '    888     8888888P"  888         Y88b d88P  888 Y88b888 888            888     \n' +
  '    888     888 T88b   888          Y88o88P   888  Y88888 888            888     \n' +
  '    888     888  T88b  888           Y888P    888   Y8888 888            888     \n' +
  '    888     888   T88b 8888888888     Y8P     888    Y888 8888888888     888     \n' +
  '                                                                                 ' +
  ' \n' +
  ' \n' +
  'Application design, architecture, development and maintenance done by TrevNet Media Corp: //trevnetmedia.com')



// WEBPACK FOOTER //
// ./src/main.js